@if (event()) {
  <div class="flex flex-col justify-center px-4">
    @if (event() && moodImageData()) {
      <div class="relative header-image mb-3 md:mb-5">
        <app-progressive-image
          [imageData]="moodImageData()"
          [imageClasses]="'w-full rounded-2xl object-cover max-h-32 md:max-h-48'"
          [loadingStrategy]="'eager'"
          [fetchPriority]="'high'">
          <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-2xl"></div>
          <div class="absolute bottom-0 left-0 right-0 p-3 md:p-4">
            <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2 sm:gap-4">
              @if (eventLocation()) {
                <div class="flex items-center gap-2">
                  <lucide-angular
                    [img]="mapPin"
                    class="text-white flex-shrink-0"
                    [attr.size]="16"
                  ></lucide-angular>
                  <span class="text-white font-bold text-sm md:text-base drop-shadow-sm">{{ eventLocation() }}</span>
                </div>
              }

              @if (eventStartDate()) {
                <div class="flex items-center gap-2">
                  <lucide-angular
                    [img]="events"
                    class="text-white flex-shrink-0"
                    [attr.size]="16"
                  ></lucide-angular>
                  <span class="text-white font-bold text-sm md:text-base drop-shadow-sm">
                  {{ eventDateCompact() }}
                </span>
                </div>
              }
            </div>
          </div>
        </app-progressive-image>
      </div>
    }
    @if (description()) {
      <!-- Header Section -->
      <app-shared-card [additionalClasses]="'mb-6 p-4'">
        <div class="flex items-start gap-2 mb-2">
        <span class="inline-block px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
          {{ getEventCategoryLabel(eventType, eventCategory) }}
        </span>
        </div>
        <h1 class="text-xl font-semibold text-gray-900 mb-2">{{ event()!.title }}</h1>

        <!-- Expandable Description -->
        <div class="mb-4">
          @if (needsExpansion()) {
            <button
              (click)="toggleDescription()"
              class="w-full text-left grid grid-cols-[1fr_auto] gap-2 items-start p-2 -m-2 cursor-pointer"
            >
              <app-markdown-card [markdownString]="displayDescription()"></app-markdown-card>

              <div class="flex items-center justify-center text-sm text-gray-500 mt-1">
                <lucide-angular
                  [img]="isDescriptionExpanded() ? chevronUp : chevronDown"
                  size="16"
                  class="transition-transform duration-200"
                ></lucide-angular>
              </div>
            </button>
          } @else {
            <app-markdown-card [markdownString]="displayDescription()"></app-markdown-card>
          }
        </div>

      </app-shared-card>
    }

    <!-- Updates Card -->
    <app-updates
      [eventDocumentId]="eventDocumentId"
      [showExpandCollapse]="true"
      [compact]="true"
      [showCard]="true"
      [cardClasses]="'mb-6 p-4'"
      [style.display]="hasUpdates ? null : 'none'">
    </app-updates>

    @if (!!event() && eventHasRegistrationDeadline(event()!)) {
      <app-link-box
        class="mb-3"
        title="Hier Anmelden"
        [url]="$any(event()!).registrationDeadline.registrationUrl"
        [active]="registerButtonActivated()"
        icon="calendar">
      </app-link-box>
    }

  </div>
}
